export default {
  collect (h, conf, key) {
    const list = []
    // const self = this
    conf.topicData.collect.forEach(item => {
      if (conf.__config__.optionType === 2) {
        list.push(
          <el-radio-button
            class="qn-custom-radio-button"
            label={item.value}
            disabled={item.disabled}
          >{item.label}</el-radio-button>
        )
      } else {
        list.push(
          <el-radio
            class="qn-custom-vertical"
            label={item.value}
            disabled={item.disabled}
          >{item.label}</el-radio>
          // h(
          //   'el-input',
          //   {
          //     domProps: {
          //       value: item.inputVal
          //     },
          //     attrs: {
          //       placeholder: '请输入'
          //     },
          //     props: {
          //       type: 'textarea',
          //       rows: 2,
          //       resize: 'none'
          //     },
          //     on: {
          //       input: (event) => {
          //         self.$emit('input', { val: event, id: item.value, type: 'slot' })
          //       }
          //     }
          //   }
          // )
        )
      }
    })
    return list
  }
}
